/**
 * AiLauncher — плавающая брендовая pill «✦ AI-помощник» в правом нижнем углу.
 *
 *  - Виден на ВСЕХ /authed страницах (рендерится в _authed.tsx)
 *  - Не виден, когда панель открыта
 *  - hover: lift -3px + усиленная тень
 *  - keyboard: focus-ring через :focus-visible
 */

import { useRouterState } from '@tanstack/react-router';
import { Icon } from '@/shared/ui';
import { useAiStore } from '@/state/aiStore';
import { zIndex } from '@/theme/tokens';

export function AiLauncher() {
  const isPanelOpen = useAiStore((s) => s.isPanelOpen);
  const openPanel = useAiStore((s) => s.openPanel);
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  // На самой странице AI-помощника плавающая pill избыточна.
  if (isPanelOpen || pathname === '/ai') return null;

  return (
    <div
      style={{
        position: 'fixed',
        right: 24,
        bottom: 24,
        zIndex: zIndex.floatingLauncher,
      }}
    >
      <button className="ai-launcher" onClick={openPanel} aria-label="Открыть AI-помощника">
        <span className="ai-launcher__spark" aria-hidden>
          <Icon name="Sparkles" size={18} />
        </span>
        <span>AI-помощник</span>
      </button>
    </div>
  );
}
